type TNavItem = {
  text: string
  link: string
}

export const menu: TNavItem[] = [
  {
    text: "Serviços",
    link: "#services",
  },
  {
    text: "Quem somos",
    link: "/quemsomos",
  },
  // {
  //   text: "Eventos",
  //   link: "/events",
  // },
  {
    text: "Quero ser prestador",
    link: "/prestador",
  },
  {
    text: "Sou Síndico",
    link: "/sindico",
  },
  {
    text: "Acessar sistema",
    link: process.env.REACT_APP_DASHBOARD_LINK ?? "",
  },
]

export const footer: TNavItem[] = [
  {
    text: "Política de privacidade",
    link: "",
  },
  {
    text: "Serviços",
    link: "#services",
  },
  {
    text: "Quem somos",
    link: "/quemsomos",
  },
  // {
  //   text: "Eventos",
  //   link: "/events",
  // },
  {
    text: "Quero ser prestador",
    link: "/prestador",
  },
]
